export default {"src":"/statics/ecommerce/_next/static/media/logo-trade-in.38d85d38.svg","height":194,"width":194,"blurWidth":0,"blurHeight":0};